import { Input, InputProps } from 'antd';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

export const ZeissInput = (props: InputProps, ref: any): any => {
  const { t } = useTranslation();
  const { bordered = true, className, maxLength, ...rest } = props;

  return (
    <Input
      placeholder={`${t('input.placeholder')}`}
      className={`${className} zeiss-reset-input ${
        bordered ? 'zeiss-input-border-bottom' : ''
      }`}
      style={{ width: '100%' }}
      autoComplete="off"
      maxLength={maxLength || 100}
      {...rest}
      ref={ref}
    />
  );
};

export default forwardRef(ZeissInput);
